import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

const Accordion = ({
    title,
    children,
    className
}: {
    title: React.ReactNode
    children: React.ReactNode
    className?: string
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggle = () => setIsOpen(!isOpen)

    return (
        <div
            className={`rounded-xl border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-white/[0.03] cursor-pointer ${className}`}
        >
            <div className='flex items-center justify-between p-3 lg:p-4 group' onClick={toggle}>
                {title}
                <ChevronDown
                    className={`h-5 w-5 text-gray-500 group-hover:text-brand-500 dark:text-gray-400 transition-transform ${
                        isOpen ? 'rotate-180' : 'rotate-0'
                    }`}
                />
            </div>
            {isOpen && (
                <div className='bg-white dark:bg-gray-800 p-4 lg:p-5 border-t border-t-gray-200 dark:border-t-gray-700'>
                    {children}
                </div>
            )}
        </div>
    )
}

export default Accordion
